import { AllPlans } from '../AllPlans'

export const BillingUpdate = () => {
    return <AllPlans />
}
